import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  itemWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemAvatar: { display: 'flex' },
  itemDescription: { marginLeft: '12px' },
  itemAccountDescription: { color: theme.palette.grey[400] },
  itemDivider: { margin: '12px 0' },
}));
